export default "__VITE_ASSET__gPjd8eyW__"